import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import './all-users.css';
import CreateAdmin from '../create-admin/create-admin';
import LoadingSpinner from '../loadspinner/loadspinner';
import { admin_list } from '../apis';

function AllUsers(props) {
  const table_headers = [
    {
      displayName: 'Created On',
      fieldName: 'created_date'
    },
    {
      displayName: 'First Name',
      fieldName: 'first_name'
    },
    {
      displayName: 'Last Name',
      fieldName: 'last_name'
    },
    {
      displayName: 'Email ID',
      fieldName: 'email'
    },
    {
      displayName: 'Tenant ID',
      fieldName: 'tenant_id'
    },
    {
      displayName: 'Tenant Name',
      fieldName: 'tenant_name'
    },
    {
      displayName: 'Product',
      fieldName: 'product_type'
    },
    {
      displayName: 'Role',
      fieldName: 'user_type'
    }
  ];
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createAdmin, setCreateAdmin] = useState(false);

  const getCurrentUserToken = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return currentUser.token || '';
  }

  useEffect(() => {
    const getAdminList = async () => {
      setLoading(true);
      let userToken = getCurrentUserToken();
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userToken}`
      }
      try {
        await axios.get(admin_list, { headers: headers })
          .then((response) => {
            const data = response.data;
            data.sort((a, b) => {
              let c = +new Date(a.created_date);
              let d = +new Date(b.created_date);
              return d - c;
            });
            const transformedData = data.map(item => ({
              ...item,
              created_date: item.created_date ? formatDateTime(item.created_date) : null
            }));
            setTableData(transformedData);
            setLoading(false);
          })
          .catch((error) => {
            if (error.response && error.response.data.message === "No record found") {
              //setEmptyData(true);
            }
            if (error.response && error.response.data.msg === "Token has expired") {
              props.onLogout('token');
            }
            setLoading(false);
          });
      } catch (error) {
        console.log("Error occurred", error);
      }
    };
    getAdminList();
  }, []);

  const formatDateTime = (dateTime) => {
    return format(new Date(dateTime), 'MMM dd yyyy hh:mm:ss a');
  };

  const handleCreateAdmin = () => {
    setCreateAdmin(true);
  }

  return (
    <div>
      {loading ? (<LoadingSpinner />) : createAdmin === false ? (
        <div className="main-users d-flex flex-column align-items-start justify-content-start">
          <div className="new-admin">
            <button className="btn btn-default d-flex flex-row align-items-center" onClick={handleCreateAdmin} >
              <img src={require('../../assets/users_blue.png')} height="20px" width="20px" alt="Add" />
              <span style={{ marginTop: "2px" }}> Add New Admin </span>
            </button>
          </div>
          <div className="all-users">
            <table>
              <thead>
                <tr>
                  {table_headers.map((column) => (
                    <th key={column.displayName}>{column.displayName}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((data, index) => (
                  <tr key={index}>
                    {table_headers.map((column) => (
                      <td key={column.fieldName}>{data[column.fieldName] ?? '-'}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <CreateAdmin  onLogout = {props.onLogout}/>
      )}
    </div>
  );
}

export default AllUsers;
